export default __webpack_public_path__ + "static/media/comedy.8e652c18.png";